<template>
  <lateral-modal
    :title="$t('transactions_edit_transaction_modal_header')"
    :containerClass="isDragging && !transactionWithoutReceipt ? 'ModalBox--dim' : ''"
    @close="closeModal"
  >
    <template
      v-if="!benefitTransactionMode"
      slot="extraAction"
    >
      <transactions-dropdown
        v-if="!isGettingTransaction"
        :transactionId.sync="transactionId"
        @confirmDelete="deleteTransaction"
      ></transactions-dropdown>
    </template>
    <template slot="content">

      <template v-if="!benefitTransactionMode">
        <modal-drop-zone
          v-if="isDragging && !transactionWithoutReceipt"
          :showDropZone.sync="isDragging"
          @dragleave="onDragleave"
          @drop="ondrop"
          :fileCount="receiptCount"
          :showSpinner="fileUploadByDrop"
        />
      </template>
      <form
        class="Form"
        @dragenter.prevent="onDragenter"
      >
        <div v-if="initialized">
          <template v-if="!benefitTransactionMode">
            <transaction-review-status-log
              :transaction="transaction"
              v-if="transactionId"
            />
          </template>
          <div class="transaction-card">
            <div
              class="transaction-details-header"
              :class="[{pending: transactionIsPending}, transactionCategory(selectedCategoryObject) ]"
              :style="{'backgroundImage': transactionCategory(selectedCategoryObject)}"
            >
              <div class="transaction-details-merchant-info">
                <div class="transaction-date-status">
                  <span class="transaction-date">
                    {{ transactionDate | formatTheDate('short_date_year_long_time_simple',true) }}
                    <inline-svg
                      :src="require('@/assets/img/icons/icon-watch.svg')"
                      v-if="transactionIsPending"
                      class="pending-icon"
                    />
                  </span>
                </div>
                <div class="transaction-amount">
                  {{ transactionAmountIntegers
            }}<span class="cents">,{{ transactionAmountDecimals }}</span>
                </div>
                <div
                  v-if="showAmountCurrency"
                  class="transaction-currency"
                >
                  <img
                    alt="info"
                    class="icon-info"
                    :src="require('@/assets/img/icons/icon-info-white.svg')"
                  >
                  <span>{{$t('transactions_edit_original_amount')}} {{amountCurrencyValue}}</span>
                </div>
                <div
                  v-if="!benefitTransactionMode"
                  class="merchant-name black ellipsis"
                  v-tooltip="transactionMerchant"
                >
                  {{ transactionMerchant }}
                </div>
              </div>
            </div>
            <template v-if="!benefitTransactionMode">
              <div class="transaction-user">
                <user-name-badge
                  :userName="transactionUserNameAndLastName"
                  :userAvatarId="transactionUserProfilePictureId"
                  overrideMargins
                  thumbSizeClass="Thumb--35"
                ></user-name-badge>
                <span class="transaction-user-text ml-2">
                  {{ transactionUserNameAndLastName }}
                </span>
              </div>
            </template>
          </div>
          <warning-container
            v-if="!benefitTransactionMode"
            :transaction="transaction"
            @showIgnoreWarning="showIgnoreWarning"
            @showTransactionModal="showTransactionModal"
          />

          <div class="row p-2">
            <template v-if="!benefitTransactionMode">
              <div class="col-12">
                <receipts-container
                  :transactionIsLocked="transactionIsLocked"
                  :isProcessing="isProcessing"
                  :transactionId="transactionId"
                  :receipts="receipts"
                  :transactionWithoutReceiptNotes="transactionWithoutReceiptNotes"
                  :transactionWithoutReceipt="transactionWithoutReceipt"
                  :required="fieldIsRequired('medias')"
                  @showReceiptModal="emitShowReceiptModal"
                  @uploadedReceipt="uploadedReceipt"
                ></receipts-container>
              </div>
              <div
                class="col-12"
                :style="{'order': inputsOrdered.indexOf('defaultCategory')}"
              >
                <div class="input--block input--block--margin input--block--padded">
                  <label
                    for="transaction-category-input"
                    class="form--label"
                    :class="fieldIsRequired('defaultCategory')"
                  >
                    {{
                    $t('transactions_edit_transaction_category').toUpperCase()
                  }}
                  </label>
                  <category-selector
                    :id="'transaction-category-selector'"
                    :disabled="transactionIsLocked || isProcessing"
                    :selectedCategoryObject.sync="selectedCategoryObject"
                    :userIsOwnerOfTransaction="userIsTransactionOwner"
                    @categorySelected="handleCategorySubcategorySelect"
                    @categoryLoaded="handleCategoryLoaded"
                  />
                </div>
              </div>
            </template>
            <div
              class="col-12"
              :style="{'order': inputsOrdered.indexOf('budget')}"
            >
              <div class="input--block input--block--margin input--block--padded">
                <label
                  for="transaction-budget-selector"
                  class="form--label"
                  :class="fieldIsRequired('budget')"
                >
                  {{ $t('BUDGETS').toUpperCase() }}
                </label>

                <div class="multiselect-filter">
                  <multi-select-input
                    :options="getBudgetsForAmount(transaction.amount)"
                    :placeholder="$t('BUDGETS')"
                    :value="budget"
                    :disabled="transactionIsLocked || isProcessing"
                    :customLabelField="'name'"
                    id="transaction-budget-selector"
                    searchable
                    emitFullValue
                    @inputSelected="setBudget($event)"
                  ></multi-select-input>
                </div>
              </div>
            </div>
            <template v-if="isFetchingBudgetTagTypes">
              <div class="d-flex justify-content-center w-100">
                <spinner />
              </div>
            </template>
            <template v-if="!isFetchingBudgetTagTypes && selectedBudgetMandatoryTagTypes.length > 0 && !benefitTransactionMode">
              <div
                v-for="item in selectedBudgetMandatoryTagTypes"
                :key="item.id"
                :style="{'order': inputsOrdered.indexOf('mandatoryTagTypes')}"
                class="input--block input--block--margin input--block--padded  mx-2"
              >
                <label
                  for="transaction-tag"
                  class="form--label"
                  :class="{ 'u-required': item.mandatory }"
                >{{ item.tagType.name.toUpperCase() }}</label>
                <div class="multiselect-custom-field">
                  <option-settings-input
                    id="transaction-tag"
                    :disabled="transactionIsLocked || isProcessing"
                    :allowMultiple="item.tagType.multipleOptionsEnabled"
                    :allowTaggable="item.tagType.customOptionEnabled"
                    :alternateOptions="item.tagType.tags"
                    useOptionSlot
                    :overrideValue="handleCustomFieldValues(item.tagType)"
                    :noOptionsLabel="
                      'company_create_transaction_field_options_no_options'
                    "
                    :noResultLabel="'multiselect_no_result_slot_default'"
                    :placeholder="item.tagType.name"
                    :tag-placeholder="
                      $t(
                        handleCreateTagPlaceholder(
                          item.tagType.customOptionEnabled
                        )
                      )
                    "
                    emitTagTypeOnClose
                    :searchable="true"
                    internalSearch
                    :customField="item.tagType"
                    :class="{ 'multiselect--error': item.invalid }"
                    closeOnSelect
                    @select="addTagToTransactionTag(item, $event)"
                    @remove="removeTagFromTransactionTag"
                    @tag="handleCreateOption(item, $event)"
                  ></option-settings-input>
                </div>
              </div>
            </template>
            <template v-if="!benefitTransactionMode">
              <div
                class="col-12"
                :style="{'order': inputsOrdered.indexOf('notes')}"
              >
                <div class="input--block input--block--margin input--block--padded">
                  <label
                    for="transaction-notes"
                    class="form--label"
                    :class="fieldIsRequired('notes')"
                  >
                    {{$t('transactions_edit_transaction_notes_field').toUpperCase()}}
                  </label>
                  <div
                    class="Form-field"
                    v-focus-input
                  >
                    <input
                      type="text"
                      class="Input-text"
                      v-model="notes"
                      :disabled="transactionIsLocked || isProcessing"
                      :placeholder="$t('transactions_edit_transaction_notes_field')"
                    />
                  </div>
                </div>
              </div>
              <div
                class="col-12"
                :style="{'order': inputsOrdered.indexOf('receiptNumber')}"
              >
                <div class="input--block input--block--margin input--block--padded">
                  <label
                    for=""
                    class="form--label"
                    :class="fieldIsRequired('receiptNumber')"
                  >
                    {{$t('transaction_edit_receipt_number').toUpperCase()}}
                  </label>
                  <multioptions-text
                    field="receiptNumber"
                    :options="options.receiptNumber"
                    :fieldValue.sync="receipt.receiptNumber"
                    :disabled="transactionIsLocked || isProcessing"
                    :placeholder="getPlaceholder('transaction_edit_receipt_number')"
                  ></multioptions-text>
                </div>
              </div>
              <div
                class="col-12"
                :style="{'order': inputsOrdered.indexOf('address')}"
              >
                <div class="input--block input--block--margin input--block--padded ">
                  <label
                    for=""
                    class="form--label"
                    :class="fieldIsRequired('address')"
                  >
                    {{
                    $t('transaction_edit_address').toUpperCase()
                  }}</label>
                  <multioptions-text
                    field="address"
                    :options="options.address"
                    :fieldValue.sync="receipt.address"
                    :disabled="transactionIsLocked || isProcessing"
                    :placeholder="getPlaceholder('transaction_edit_address')"
                    :vuelidateElement="$v.receipt.address"
                  ></multioptions-text>
                </div>
              </div>
              <div
                class="col-12"
                :style="{'order': inputsOrdered.indexOf('zipCode')}"
              >
                <div class="input--block input--block--margin input--block--padded">
                  <label
                    for=""
                    class="form--label"
                    :class="fieldIsRequired('zipCode')"
                  >
                    {{
                    $t('transaction_edit_zip_code').toUpperCase()
                  }}</label>
                  <multioptions-text
                    field="zipCode"
                    :options="options.zipCode"
                    :fieldValue.sync="receipt.zipCode"
                    :disabled="transactionIsLocked || isProcessing"
                    :placeholder="getPlaceholder('transaction_edit_zip_code')"
                    :vuelidateElement="$v.receipt.zipCode"
                  ></multioptions-text>
                </div>
              </div>
              <div
                class="col-12"
                :style="{'order': inputsOrdered.indexOf('city')}"
              >
                <div class="input--block input--block--margin input--block--padded ">
                  <label
                    for=""
                    class="form--label"
                    :class="fieldIsRequired('city')"
                  >
                    {{
                    $t('transaction_edit_city').toUpperCase()
                  }}</label>
                  <multioptions-text
                    field="city"
                    :options="options.city"
                    :fieldValue.sync="receipt.city"
                    :disabled="transactionIsLocked || isProcessing"
                    :placeholder="getPlaceholder('transaction_edit_city')"
                    :vuelidateElement="$v.receipt.city"
                  ></multioptions-text>
                </div>
              </div>
              <div
                class="col-12"
                :style="{'order': inputsOrdered.indexOf('state')}"
              >
                <div class="input--block input--block--margin input--block--padded ">
                  <label
                    for=""
                    class="form--label"
                    :class="fieldIsRequired('state')"
                  >
                    {{
                    $t('transaction_edit_state').toUpperCase()
                  }}</label>
                  <multioptions-text
                    field="state"
                    :options="options.state"
                    :fieldValue.sync="receipt.state"
                    :disabled="transactionIsLocked || isProcessing"
                    :placeholder="getPlaceholder('transaction_edit_state')"
                    :vuelidateElement="$v.receipt.state"
                  ></multioptions-text>
                </div>
              </div>
              <div
                class="col-12"
                :style="{'order': inputsOrdered.indexOf('country')}"
              >
                <div class="input--block input--block--margin input--block--padded ">
                  <label
                    for=""
                    class="form--label"
                    :class="fieldIsRequired('country')"
                  >
                    {{
                    $t('transaction_edit_country').toUpperCase()
                  }}</label>
                  <multioptions-text
                    field="country"
                    :options="options.country"
                    :fieldValue.sync="receipt.country"
                    :disabled="transactionIsLocked || isProcessing"
                    :placeholder="getPlaceholder('transaction_edit_country')"
                    :vuelidateElement="$v.receipt.country"
                  ></multioptions-text>
                </div>
              </div>
            </template>
            <template v-if="isFetchingBudgetTagTypes">
              <div class="d-flex justify-content-center w-100">
                <spinner />
              </div>
            </template>
            <template v-if="!isFetchingBudgetTagTypes && selectedBudgetNoMandatoryTagTypes.length > 0 && !benefitTransactionMode">
              <div
                v-for="item in selectedBudgetNoMandatoryTagTypes"
                :key="item.id"
                :style="{'order': inputsOrdered.indexOf('noMandatoryTagTypes')}"
                class="input--block input--block--margin input--block--padded  mx-2"
              >
                <label
                  for="transaction-tag"
                  class="form--label"
                  :class="{ 'u-required': item.mandatory }"
                >{{ item.tagType.name.toUpperCase() }}</label>
                <div class="multiselect-custom-field">
                  <option-settings-input
                    id="transaction-tag"
                    :disabled="transactionIsLocked || isProcessing"
                    :allowMultiple="item.tagType.multipleOptionsEnabled"
                    :allowTaggable="item.tagType.customOptionEnabled"
                    :alternateOptions="item.tagType.tags"
                    useOptionSlot
                    :overrideValue="handleCustomFieldValues(item.tagType)"
                    :noOptionsLabel="
                      'company_create_transaction_field_options_no_options'
                    "
                    :noResultLabel="'multiselect_no_result_slot_default'"
                    :placeholder="item.tagType.name"
                    :tag-placeholder="
                      $t(
                        handleCreateTagPlaceholder(
                          item.tagType.customOptionEnabled
                        )
                      )
                    "
                    emitTagTypeOnClose
                    :searchable="true"
                    internalSearch
                    :customField="item.tagType"
                    :class="{ 'multiselect--error': item.invalid }"
                    closeOnSelect
                    @select="addTagToTransactionTag(item, $event)"
                    @remove="removeTagFromTransactionTag"
                    @tag="handleCreateOption(item, $event)"
                  ></option-settings-input>
                </div>
              </div>
            </template>
            <!-- Bloque AEAT TAXS -->
            <div
              v-if="!benefitTransactionMode"
              class="input--block input--block--margin input--block--padded mx-2"
              :style="{'order': inputsOrdered.indexOf('vatTypeAssigned')}"
            >
              <label
                for=""
                class="form--label"
                :class="fieldIsRequired('vatTypeAssigned')"
              >{{$t('transactions_edit_transaction_tax_region_selector').toUpperCase()}}</label>
              <div class="multiselect-filter">
                <multiselect
                  :id="'transaction-tax-region-picker'"
                  :options="vatTypes"
                  :disabled="transactionIsLocked || isProcessing"
                  v-model="selectedVatRegion"
                  :placeholder="
                    $t('transactions_edit_transaction_tax_region_selector')
                  "
                  track-by="id"
                  label="place"
                  :selectLabel="''"
                  :searchable="false"
                  :allowEmpty="false"
                  :showLabels="false"
                  :selectedLabel="''"
                  @input="recalculateVat"
                >
                  <div
                    class="caret"
                    slot="caret"
                    slot-scope="{ toggle }"
                    @mousedown.prevent.stop="toggle"
                  >
                    <i
                      class="Ctrl Ctrl--16"
                      aria-hidden="true"
                    >
                      <svg
                        focusable="false"
                        aria-hidden="true"
                        aria-label="Edit"
                      >
                        <use xlink:href="#dropdown-icon"></use>
                      </svg>
                    </i>
                  </div>
                  <template slot="noOptions">
                    <span class="no-result">
                      {{ $t('multiselect_no_options_slot_default') }}
                    </span>
                  </template>
                  <template
                    slot="singleLabel"
                    slot-scope="props"
                  >
                    <div class="d-flex">
                      <div class="flag-container ">
                        <img
                          :alt="`icon-flag-${props.option.place}`"
                          :src="getFlagIcon(props.option)"
                          class="mr-2 currency-flag-image"
                        />
                      </div>
                      <span class="my-auto ml-2">{{ props.option.place }}</span>
                    </div>
                  </template>
                  <template
                    slot="option"
                    slot-scope="props"
                  >
                    <div class="d-flex">
                      <div class="flag-container my-auto">
                        <img
                          :alt="`icon-flag-${props.option.place}`"
                          :src="getFlagIcon(props.option)"
                          class="mr-2 currency-flag-image"
                        />
                      </div>
                      <span class="my-auto ml-2">{{ props.option.place }}</span>
                    </div>
                  </template>
                </multiselect>
              </div>
            </div>
            <div
              v-if="!benefitTransactionMode"
              class="col-12 mt-1"
              :style="{'order': inputsOrdered.indexOf('taxes')}"
            >
              <div class="input-block input--block--margin input--block--paded">
                <!-- Bloque 21% --->
                <div
                  class="d-flex justify-content-between mb-2"
                  v-for="(vatTypeValue, index) in orderedVatTypes()"
                  :key="vatTypeValue[0]"
                >
                  <!-- TAX BASE -->
                  <div class="d-flex flex-column">
                    <label
                      class="form--label pl-2"
                      v-if="index === 0"
                      :class="{ 'u-required': fieldIsRequired('taxes') }"
                    >
                      {{ $t("transactions_edit_tax_base").toUpperCase() }}
                    </label>
                    <div class="d-flex align-items-center">
                      <div>
                        <multioptions-text
                          :options="getOptions(`taxBase${index+1}`)"
                          money
                          :type="'money'"
                          :containerClass="'Form-field Form-field--short-tax'"
                          :fieldValue.sync="taxes[vatTypeValue[0]].taxBase"
                          :disabled="transactionIsLocked || isProcessing"
                          :class="{
                            'tax-zero-color': taxes[vatTypeValue[0]].taxBase === 0,
                          }"
                          :manualErrorFlag="taxes[vatTypeValue[0]].error || taxesRequiredValidationError"
                          @focus="clearZeroTax(vatTypeValue[0])"
                          @blur="handleVatCalculation(
                            taxes[vatTypeValue[0]].taxBase,
                            vatTypeValue[1],
                            vatTypeValue[0]
                          ); checkVat(); validateTaxesRequired()"
                        >
                        </multioptions-text>
                      </div>
                      <span class="currency-symbol">€</span>
                    </div>
                  </div>

                  <!-- ARROW BLOCK -->
                  <div class="d-flex align-items-center">
                    <span
                      class="Fuell-aeat-arrow-right Fuell-aeat-arrow-right--pointer"
                      :class="{'Fuell-aeat-arrow-right--first' : index === 0}"
                      @click="calculateTaxes(vatTypeValue[1], vatTypeValue[0])"
                    >
                      <span class="Fuell-aeat-arrow-right--text">{{ vatTypeValue[1] }}%</span>
                    </span>
                  </div>

                  <!-- VAT BLOCK -->
                  <div class="d-flex flex-column">
                    <label
                      class="form--label pl-2"
                      v-if="index === 0"
                    >
                      {{ $t('transactions_edit_quota').toUpperCase() }}</label>
                    <div class="Form-field Form-field--white Form-field--short position-relative">
                      <currency-input
                        class="Fuell-Text-Input Fuell-Text-Input--white Fuell-Text-Input--short Fuell-Text-Input--border-bottom"
                        disabled
                        :currency="null"
                        :value="taxes[vatTypeValue[0]].vat"
                        :class="{ 'tax-zero-color': taxes[vatTypeValue[0]].vat === 0 }"
                        :allow-negative="false"
                      ></currency-input>
                      <span class="currency-symbol position-absolute">€</span>
                    </div>
                  </div>
                </div>
              </div>
              <div
                v-if="taxesError"
                class="taxes-error"
              >
                <img
                  alt="transaction-warning-icon"
                  :src="require(`@/assets/img/icons/icon-warning-red.svg`)"
                />
                <span>{{$t('transaction_taxes_error')}}</span>
              </div>
            </div>
            <!--. Fin Bloque AEAT   -->
            <div
              v-if="!benefitTransactionMode"
              class="col-12"
              :style="{'order': inputsOrdered.indexOf('providerData')}"
            >
              <div class="input--block input--block--margin input--block--padded">
                <label
                  for=""
                  class="form--label"
                  :class="fieldIsRequired('providerData')"
                >
                  {{ $t('transactions_edit_cif_field').toUpperCase() }}
                </label>
                <multioptions-text
                  field="providerData"
                  :options="options.providerData"
                  :disabled="transactionIsLocked || isProcessing"
                  :fieldValue.sync="receipt.providerData"
                  :placeholder="getPlaceholder('transactions_edit_cif_field')"
                  :vuelidateElement="$v.receipt.providerData"
                ></multioptions-text>
              </div>
            </div>

            <div
              v-if="!benefitTransactionMode"
              class="col-12"
              :style="{'order': inputsOrdered.indexOf('provider')}"
            >
              <div class="input--block input--block--margin input--block--padded ">
                <label
                  for=""
                  class="form--label"
                  :class="fieldIsRequired('provider')"
                >
                  {{$t('transactions_edit_social_reason_field').toUpperCase()}}
                </label>
                <multioptions-text
                  field="provider"
                  :options="options.provider"
                  :fieldValue.sync="receipt.provider"
                  :disabled="transactionIsLocked || isProcessing"
                  :placeholder="getPlaceholder('transactions_edit_social_reason_field')"
                  :vuelidateElement="$v.receipt.provider"
                ></multioptions-text>
              </div>
            </div>
          </div>
        </div>
        <div v-else>
          <div class="w-100 h-100 d-flex justify-content-center align-items-center">
            <spinner v-if="isGettingTransaction || !initialized"></spinner>
          </div>
        </div>
      </form>
    </template>
    <template slot="footer">
      <template v-if="!isGettingTransaction && initialized && !transactionIsLocked && !isSendingTransaction && !isProcessing">
        <template v-if="isDirty && (categoriesLoaded || benefitTransactionMode)">
          <button
            class="Fuell-Button blue block w-100"
            :disabled="transactionIsLocked || !isDirty || isProcessing"
            :class="{ blue: !transactionIsLocked || !isProcessing }"
            @click.prevent="editTransaction"
          >
            <span class="Fuell-Button--label">
              {{ $t('transactions_edit_transaction_save') }}
            </span>
          </button>
        </template>
        <template v-else>
          <template v-if="!isInExpensesSection && !benefitTransactionMode">
            <funnel-actions
              v-show="reviewStatus && categoriesLoaded"
              @reviewStatusChanged="emitReviewStatusChanged"
              :reviewStatus.sync="reviewStatus"
              :budgetOwner="isBudgetOwner"
              :expenseOwner="transactionOwner"
              :transactionId.sync="transactionId"
            />
          </template>
        </template>
      </template>
      <template v-if="isSendingTransaction">
        <div class="w-100 h-100 d-flex justify-content-center align-items-center">
          <spinner></spinner>
        </div>
      </template>
    </template>
    <template slot="modals">
      <confirm-modal
        v-if="showIgnoreWarningModal"
        :open.sync="showIgnoreWarningModal"
        :modalClass="'ModalBox--400'"
        :title="'transaction_warning_ignore_modal'"
        :message="'transaction_warning_ignore_message'"
        :acceptText="'transaction_warning_ignore'"
        :dismissText="'ACTION_CANCEL'"
        acceptBtnClass="blue"
        dismissBtnClass="danger"
        @accept="ignoreWarning"
        @dismiss="dismissWarning"
      ></confirm-modal>
      <confirm-modal
        v-if="showUploadInProgress"
        :open.sync="showUploadInProgress"
        :modalClass="'ModalBox--400'"
        :title="''"
        :message="''"
        :acceptText="'transaction_upload_in_progress_understood'"
        acceptBtnClass="blue"
        closeButton
        noPadding
        noMargin
        hideDismissButton
        @accept="uploadingAccept"
      >
        <template v-slot:content>
          <div class="transaction-upload-in-progress">
            <img
              :src="require('@/assets/img/upload-in-progress.svg')"
              alt=""
            />
            <p class="transaction-upload-in-progress--title">{{ $t('transaction_upload_in_progress_title') }}</p>
            <p class="transaction-upload-in-progress--description">{{ $t('transaction_upload_in_progress_description') }}</p>
          </div>
        </template>
      </confirm-modal>
      <choose-media-type-modal
        v-if="showMediaTypeModalFlag"
        :open.sync="showMediaTypeModalFlag"
        @typeSelected="typeIsSelected"
      ></choose-media-type-modal>
    </template>
  </lateral-modal>
</template>
<script>
import Multiselect from 'vue-multiselect'
import { DEFAULT_CURRENCY } from '@/utils/constants'
import { currency } from '@/filters'
import _modalHandlerMixin from '@/components/Commons/_mixins/_modalHandlerMixin'
import _transactionsTableRowInfo from '../../_mixins/_transactionsTableRowInfo'
import _transactionsCustomFieldsHandler from '../../_mixins/_transactionsCustomFieldsHandler'
import _transactionTaxesHandler from '../../_mixins/_transactionTaxesHandler'
import _transactionAndExpenseCommon from '../../_mixins/_transactionAndExpenseCommon'
import _transactionReceiptHandler from '../../_mixins/_transactionReceiptDragAndDropHandler'
import _transactionStatusHandlerMixin from '../../_mixins/_transactionStatusHandlerMixin'
import _transactionsValidationHandlerMixin from '../../_mixins/_transactionsValidationHandlerMixin'
import _transactionsTicketHandlerMixin from '../../_mixins/_transactionsTicketHandlerMixin'
import _expenseIntervalHandlerMixin from '../../_mixins/_expenseIntervalHandlerMixin'
import TransactionReviewStatusLog from '../funnel/statusLog/TransactionReviewStatusLog.vue'
import FunnelActions from '../funnel/FunnelActions.vue'
import UserNameBadge from '@/components/Commons/UserNameBadge'
import MultiSelectInput from '@/components/Commons/Forms/MultiSelectInput'
import OptionSettingsInput from '@/modules/company/_components/_shared/OptionSettingsInput.vue'
import InlineSvg from 'vue-inline-svg'
import { uniqBy } from 'lodash-es'
import Spinner from '@/components/Commons/Spinner'
import ModalDropZone from '@/components/Commons/ModalDropZone'
import WarningContainer from '../_shared/WarningContainer.vue'
import ReceiptsContainer from '@/components/Commons/ReceiptsContainer.vue'
import CategorySelector from '../_shared/CategorySelector.vue'
import { INCLUDE_IN_TRANSACTION_TYPES } from '../../_constants/constants'
import MultioptionsText from '@/components/Commons/MultioptionsText'
import LateralModal from '@/components/Commons/Modals/LateralModal'
const TransactionsDropdown = () => import('../_shared/TransactionsDropdown')
const ConfirmModal = () => import('@/components/Commons/ConfirmModal')
const ChooseMediaTypeModal = () => import('@/modules/transactions/_components/media/ChooseMediaTypeModal.vue')

export default {
  name: 'TransactionsEditModal',
  mixins: [
    _modalHandlerMixin,
    _transactionsTableRowInfo,
    _transactionsCustomFieldsHandler,
    _transactionTaxesHandler,
    _transactionAndExpenseCommon,
    _transactionReceiptHandler,
    _transactionStatusHandlerMixin,
    _transactionsValidationHandlerMixin,
    _transactionsTicketHandlerMixin,
    _expenseIntervalHandlerMixin
  ],
  props: {
    // transactionId: [Number, String], ==>  MOVED TO MIXIN _transactionAndExpenseCommon
    benefitTransactionMode: {
      type: Boolean,
      default: false
    }
  },
  components: {
    WarningContainer,
    UserNameBadge,
    InlineSvg,
    Spinner,
    Multiselect,
    OptionSettingsInput,
    CategorySelector,
    ModalDropZone,
    FunnelActions,
    TransactionReviewStatusLog,
    ConfirmModal,
    TransactionsDropdown,
    MultioptionsText,
    ReceiptsContainer,
    LateralModal,
    ChooseMediaTypeModal,
    MultiSelectInput
  },
  computed: {

    canBeSaved () {
      return !this.$v.$invalid
    },
    categories () {
      return this.$store.getters['CategoriesStore/categories'] || []
    },
    showAmountCurrency () {
      return this.transaction?.currencyAmount?.originalCurrencyCode !== DEFAULT_CURRENCY
    },
    amountCurrencyValue () {
      return currency(this.transaction.currencyAmount.amountOriginalCurrency, this.transaction?.currencyAmount?.originalCurrencyCode)
    },
    isDirty () {
      if (this.transaction && this.transaction.receipt) {
        const original = { ...this.originalTransactionModel }

        original.receipt.receiptMedia = null
        original.receipt.accountingDate = null
        const current = { ...this.generateTransactionModel() }

        current.receipt.receiptMedia = null
        current.receipt.accountingDate = null

        return JSON.stringify(original) !== JSON.stringify(current)
      }
      return true
    },
    transactionAmountToDisplay () {
      return this.transaction
        ? this.$options.filters.currency(this.transaction.amount, '€', 2, {
          symbolOnLeft: false,
          thousandsSeparator: '.',
          decimalSeparator: ','
        })
        : 0
    },
    transactionAmountIntegers () {
      return this.transaction
        ? `${this.transactionAmountToDisplay}`.split(',')[0]
        : '0'
    },
    transactionAmountDecimals () {
      return this.transaction
        ? `${this.transactionAmountToDisplay}`.split(',')[1]
        : '00 €'
    },
    transactionReceipts () {
      return this.transaction && this.transaction.receipts
        ? this.transaction.receipts
        : []
    },
    isExpense () {
      return this.transactionType === 'EXPENSE'
    },
    isLoadingTransactions () {
      return this.$store.getters['TransactionsStore/isLoadingTransactions']
    },
    selectedBudget () {
      return this.budgets.find(el => el.id === this.budget.id)
    },

    transactionLockedLabel () {
      return this.$t('transaction_edit_locked_transaction_label', {
        date: this.$moment.utc(this.transaction.lockedAt).format('DD/MM/YY HH:mm')
      })
    },
    currentUser () {
      return this.$store.getters['UsersStore/userLogged']
    },
    userHasDevoluiva () {
      return this.currentUser && this.currentUser.office && this.currentUser.office.customer && this.currentUser.office.customer.isDevoluivaActivated
    },
    isSuperBook () {
      return this.$store.getters['LoginStore/isSuperBookKeeper']
    },
    // Susceptible de moverse a mixin
    reviewStatus () {
      return this.transaction && this.transaction.reviewStatus ? this.transaction.reviewStatus.code : false
    },
    isBudgetOwner () {
      return this.transaction && this.transaction.budget ? this.transaction.budget.imOwner : false
    },
    transactionOwner () {
      return this.transaction && this.transaction.card ? this.transaction.card.user : false
    },
    userIsTransactionOwner () {
      return this.transactionOwner ? this.transactionOwner.id === this.currentUserId : false
    }
  },
  data () {
    return {
      initialized: false,
      originalTransactionModel: null,
      budget: '',
      files: null,
      notes: '',
      selectedCategory: '',
      selectedSubCategory: '',
      selectedCategoryObject: null,
      transactionTags: [],
      isGettingTransaction: false,
      expenseType: 'TRANSACTION',
      showIgnoreWarningModal: false,
      amountOriginalCurrency: null,
      // Analytics purposes
      transactionTagUpdatedFlag: false,
      categoriesLoaded: false,
      receipt: {
        receiptNumber: null,
        provider: '',
        providerData: '',
        totalReceipt: '',
        taxBase1: 0,
        vatType1: 21,
        vat1: 0,
        taxBase2: 0,
        vatType2: 10,
        vat2: 0,
        taxBase3: 0,
        vatType3: 4,
        vat3: 0,
        taxBase4: 0,
        vatType4: 0,
        vat4: 0,
        taxBase5: 0,
        vat5: 0,
        vatType5: 0,
        taxBase6: 0,
        vat6: 0,
        vatType6: 0,
        date: null,
        address: '',
        zipCode: '',
        city: '',
        country: '',
        state: ''
      },
      selectedVatRegion: {},
      isSendingTransaction: false,
      sendToDevoluivaFlag: false
    }
  },
  methods: {
    getPlaceholder (text) {
      return this.isProcessingReceipts ? this.$t('transactions_receipt_processing') + ' ' + this.$t(text).toLowerCase() : this.$t(text)
    },
    handleCategoryLoaded () {
      this.categoriesLoaded = true
    },
    transactionCategory (category) {
      category = category || {}
      let className = ''
      let fullCategory = this.categories.find(el => el.id === category.categoryId) || false

      if (fullCategory?.headerImageUrl) {
        className = `url(${fullCategory.headerImageUrl})`
      } else {
        switch (fullCategory.code) {
          case '001':
            className = 'food-and-drinks'
            break
          case '002':
            className = 'office'
            break
          case '003':
            className = 'travel-and-transport'
            break
          case '004':
            className = 'others'
            break
          case '005':
            className = 'computing'
            break
          case '007':
            className = 'comunications'
            break
          case '008':
            className = 'software-and-hardware'
            break
          case '009':
            className = 'training-or-entertainment'
            break
          case '010':
            className = 'marketing-and-advertising'
            break
          default:
            className = 'default'
            break
        }
      }

      return className
    },

    handleCategorySubcategorySelect (subcategory) {
      this.selectedCategoryObject = subcategory
      this.selectedCategoryId = subcategory.categoryId
      this.selectedSubCategory = subcategory.subcategoryId
      this.handleTaxInitialization(subcategory)
    },
    emitReviewStatusChanged () {
      this.$emit('reviewStatusChanged')
    },
    setField (field, event) {
      if (event && event.target && event.target.value) {
        this[field] = event.target.value
      } else {
        this[field] = event
      }
    },
    clearZeroTax (vatType) {
      if (this.taxes[vatType].taxBase === 0) {
        this.taxes[vatType].taxBase = null
      }
    },

    getBudgetsForAmount (amount) {
      const allBudgets = [{ ...this.transaction.budget }, ...this.budgets]

      const budgetsFinal = allBudgets
        .map(budget => {
          const budgetOption = budget.budget ? { ...budget.budget } : { ...budget }
          const availableFunds = budget.available
          budgetOption.activityGroup = budget.activityGroup
          if (amount >= 0) {
            budgetOption.$isDisabled = false
          } else {
            if (
              availableFunds < Math.abs(amount) &&
              budgetOption.id !== this.budget.id
            ) {
              budgetOption.$isDisabled = true
              budgetOption.name += ` - ${this.$t(
                'transactions_budget_not_funds_enough'
              )}`
            } else {
              budgetOption.$isDisabled = false
            }
            if (budgetOption.status && budgetOption.status.code === 'ARCHIVED') {
              budgetOption.$isDisabled = true
              budgetOption.name += ` - ${this.$t('budgets_budget_status__ARCHIVED')}`
            }
          }
          return budgetOption
        })
        .filter(el => {
          return (this.transaction.budget && el.id === this.transaction.budget.id) || (el.status && el.status.code === 'ACTIVE')
        }).filter(el => {
          if (el.type.code === 'FLEXIBLE_REMUNERATION') {
            if (el.activityGroup && this.transaction.activityGroup) {
              if (el.activityGroup.code === this.transaction.activityGroup.code) {
                return el
              }
            }
          } else {
            return el
          }
        })
        .sort((a, b) => a.$isDisabled - b.$isDisabled)
      return uniqBy(budgetsFinal, 'id')
    },
    async fetchCurrentTransactionUserBudgets () {
      let filters = {}
      filters = {
        'budget.status.code': ['ACTIVE'],
        'user.id[]': this.transactionUserId,
        isMember: true
      }
      if (this.transaction.id) {
        filters['budget.status.code'].push('ARCHIVED')
      }
      await this.$store.dispatch('UsersStore/fetchUserBudgets', {
        page: 0,
        pagination: false,
        filters: filters
      })
    },
    generateTransactionModel () {
      const transactionModel = {
        id: this.transaction.id
      }

      transactionModel.notes = this.notes

      if (this.budget) {
        transactionModel.budget = { id: this.budget.id }
      }
      if (this.files) {
        transactionModel.files = this.files
      }
      if (
        this.selectedCategoryObject?.subcategoryId > 0
      ) {
        transactionModel.customCategory = {
          id: this.selectedCategoryObject.subcategoryId
        }
      } else if (this.transaction?.customCategory?.id > 0) {
        transactionModel.customCategory = {
          id: this.transaction.customCategory.id
        }
      } else {
        transactionModel.customCategory = null
      }
      // if (this.transaction.customCategory) {
      //   transactionModel.customCategory = {
      //     id: this.transaction.customCategory.id
      //   }
      // }
      if (this.transactionTags.length > 0) {
        const formatedTransactionTags = this.transactionTags.map(el => {
          if (typeof el.tag.id === 'string') {
            const formated = {
              tag: {
                name: el.tag.name,
                type: { ...el.tag.type }
              }
            }
            return formated
          } else {
            return { tag: el.tag }
          }
        })

        transactionModel.transactionTags = formatedTransactionTags
      } else {
        transactionModel.transactionTags = []
      }
      transactionModel.receipt = {}

      if (this.transaction?.receipt?.id) {
        transactionModel.receipt.id = this.transaction.receipt.id
      }
      transactionModel.receipt.totalReceipt = Math.abs(this.transaction.amount)
      transactionModel.receipt.date = this.transaction.date
      transactionModel.receipt.address = this.receipt.address ? this.receipt.address : ''
      transactionModel.receipt.zipCode = this.receipt.zipCode ? this.receipt.zipCode : ''
      transactionModel.receipt.city = this.receipt.city ? this.receipt.city : ''
      transactionModel.receipt.state = this.receipt.state ? this.receipt.state : ''
      transactionModel.receipt.country = this.receipt.country ? this.receipt.country : ''

      if (this.receipt.provider) {
        transactionModel.receipt.provider = this.receipt.provider
      }
      if (this.receipt.providerData) {
        transactionModel.receipt.providerData = this.receipt.providerData
      }
      if (this.receipt.receiptNumber) {
        transactionModel.receipt.receiptNumber = this.receipt.receiptNumber
      }
      if (this.taxes) {
        transactionModel.receipt.vat1 = this.taxes.vatType1.vat
        transactionModel.receipt.taxBase1 = this.taxes.vatType1.taxBase
      }
      transactionModel.receipt.vatType1 =
        this.selectedVatRegion.vatType1 === null
          ? 0
          : this.selectedVatRegion.vatType1
      transactionModel.receipt.vat2 = this.taxes.vatType2.vat
      transactionModel.receipt.taxBase2 = this.taxes.vatType2.taxBase
      transactionModel.receipt.vatType2 =
        this.selectedVatRegion.vatType2 === null
          ? 0
          : this.selectedVatRegion.vatType2

      transactionModel.receipt.vat3 = this.taxes.vatType3.vat
      transactionModel.receipt.taxBase3 = this.taxes.vatType3.taxBase
      transactionModel.receipt.vatType3 =
        this.selectedVatRegion.vatType3 === null
          ? 0
          : this.selectedVatRegion.vatType3
      transactionModel.receipt.vat4 = this.taxes.vatType4.vat
      transactionModel.receipt.taxBase4 = this.taxes.vatType4.taxBase
      transactionModel.receipt.vatType4 =
        this.selectedVatRegion.vatType4 === null
          ? 0
          : this.selectedVatRegion.vatType4
      transactionModel.receipt.vat5 = this.taxes.vatType5.vat
      transactionModel.receipt.taxBase5 = this.taxes.vatType5.taxBase
      transactionModel.receipt.vatType5 =
        this.selectedVatRegion.vatType5 === null
          ? 0
          : this.selectedVatRegion.vatType5
      transactionModel.receipt.vat6 = this.taxes.vatType6.vat
      transactionModel.receipt.taxBase6 = this.taxes.vatType6.taxBase
      transactionModel.receipt.vatType6 =
        this.selectedVatRegion.vatType6 === null
          ? 0
          : this.selectedVatRegion.vatType6

      if (this.selectedVatRegion && this.selectedVatRegion.id) {
        transactionModel.receipt.vatTypeAssigned = {
          id: this.selectedVatRegion.id
        }
      }

      transactionModel.receipt.accountingDate = this.$moment.utc().format()
      return transactionModel
    },
    async editTransaction () {
      if (this.isSendingTransaction) return
      const transactionModel = this.generateTransactionModel()

      if (this.originalTransactionModel.receipt.receiptNumber !== transactionModel.receipt.receiptNumber) {
        transactionModel.hasManualModifications = true
      }
      if (this.originalTransactionModel.receipt.provider !== transactionModel.receipt.provider) {
        transactionModel.hasManualModifications = true
      }

      if (this.originalTransactionModel.receipt.providerData !== transactionModel.receipt.providerData) {
        transactionModel.hasManualModifications = true
      }
      if (this.originalTransactionModel.receipt.taxBase1 !== transactionModel.receipt.taxBase1) {
        transactionModel.hasManualModifications = true
      }

      if (this.originalTransactionModel.receipt.taxBase2 !== transactionModel.receipt.taxBase2) {
        transactionModel.hasManualModifications = true
      }

      if (this.originalTransactionModel.receipt.taxBase3 !== transactionModel.receipt.taxBase3) {
        transactionModel.hasManualModifications = true
      }

      if (this.originalTransactionModel.receipt.taxBase4 !== transactionModel.receipt.taxBase4) {
        transactionModel.hasManualModifications = true
      }

      if (this.originalTransactionModel.receipt.taxBase5 !== transactionModel.receipt.taxBase5) {
        transactionModel.hasManualModifications = true
      }

      if (this.originalTransactionModel.receipt.taxBase6 !== transactionModel.receipt.taxBase6) {
        transactionModel.hasManualModifications = true
      }
      if (this.originalTransactionModel.receipt.vat1 !== transactionModel.receipt.vat1) {
        transactionModel.hasManualModifications = true
      }

      if (this.originalTransactionModel.receipt.vat2 !== transactionModel.receipt.vat2) {
        transactionModel.hasManualModifications = true
      }

      if (this.originalTransactionModel.receipt.vat3 !== transactionModel.receipt.vat3) {
        transactionModel.hasManualModifications = true
      }

      if (this.originalTransactionModel.receipt.vat4 !== transactionModel.receipt.vat4) {
        transactionModel.hasManualModifications = true
      }

      if (this.originalTransactionModel.receipt.vat5 !== transactionModel.receipt.vat5) {
        transactionModel.hasManualModifications = true
      }

      if (this.originalTransactionModel.receipt.vat6 !== transactionModel.receipt.vat6) {
        transactionModel.hasManualModifications = true
      }

      if (this.originalTransactionModel.receipt.vatType1 !== transactionModel.receipt.vatType1) {
        transactionModel.hasManualModifications = true
      }

      if (this.originalTransactionModel.receipt.vatType2 !== transactionModel.receipt.vatType2) {
        transactionModel.hasManualModifications = true
      }
      if (this.originalTransactionModel.receipt.vatType3 !== transactionModel.receipt.vatType3) {
        transactionModel.hasManualModifications = true
      }
      if (this.originalTransactionModel.receipt.vatType4 !== transactionModel.receipt.vatType4) {
        transactionModel.hasManualModifications = true
      }
      if (this.originalTransactionModel.receipt.vatType5 !== transactionModel.receipt.vatType5) {
        transactionModel.hasManualModifications = true
      }
      if (this.originalTransactionModel.receipt.vatType6 !== transactionModel.receipt.vatType6) {
        transactionModel.hasManualModifications = true
      }

      this.isSendingTransaction = true

      await this.$store
        .dispatch('TransactionsStore/editTransaction', {
          transactionInformation: transactionModel,
          transactionTagUpdatedFlag: this.transactionTagUpdatedFlag,
          originalTransaction: this.transaction
        })
        .then(() => {
          this.$emit('budgetUpdated')
          if (this.$store.getters['TransactionsStore/currentTransaction'].isCompleted) {
            this.$emit('transactionCompleted')
          }

          this.isSendingTransaction = false
          this.transactionTagUpdatedFlag = false

          this.closeModal()
          this.$emit('showTransactionModal', this.transaction, this.transactionType === 'EXPENSE' ? 'expense' : undefined)
        })
    },
    async fetchTransaction () {
      try {
        if (!this.transactionId) return

        this.isGettingTransaction = true

        await this.$store.dispatch(
          'TransactionsStore/fetchTransaction',
          this.transactionId
        )
      } catch (error) {
      } finally {
        this.isGettingTransaction = false
      }
    },
    handleUploadReceipt () {
      this.$refs.receiptImageFileInput.$el.dispatchEvent(new Event('click'))
    },
    _initializeTransaction () {
      this.notes = this.transaction.notes ? this.transaction.notes : ''
      this.budget = this.transaction.budget ? this.transaction.budget : ''
      this.transactionTags = this.transaction.transactionTags
        ? this.transaction.transactionTags
        : []

      this.selectedBudgetTagTypes = this.transaction.budget ? this.transaction.budget.budgetTagTypes.filter(el => el.tagType.includeInTransactionTypes.includes(INCLUDE_IN_TRANSACTION_TYPES.TRANSACTION)) : []

      this.receipt.receiptNumber =
        this.transaction.receipt && this.transaction.receipt.receiptNumber
          ? this.transaction.receipt.receiptNumber
          : null
      this.receipt.provider =
        this.transaction.receipt && this.transaction.receipt.provider
          ? this.transaction.receipt.provider
          : null
      this.receipt.providerData =
        this.transaction.receipt && this.transaction.receipt.providerData
          ? this.transaction.receipt.providerData
          : null
      this.receipt.address = this.transaction.receipt && this.transaction.receipt.address ? this.transaction.receipt.address : ''
      this.receipt.zipCode = this.transaction.receipt && this.transaction.receipt.zipCode ? this.transaction.receipt.zipCode : ''
      this.receipt.city = this.transaction.receipt && this.transaction.receipt.city ? this.transaction.receipt.city : ''
      this.receipt.state = this.transaction.receipt && this.transaction.receipt.state ? this.transaction.receipt.state : ''
      this.receipt.country = this.transaction.receipt && this.transaction.receipt.country ? this.transaction.receipt.country : ''

      this.amountOriginalCurrency = this.transaction.amount
      this.transactionReviewedFlag = this.transaction.reviewedAt !== null
      this.sendToDevoluivaFlag = this.transaction.receipt ? this.transaction.receipt.doNotSendDevoluiva : false
      this.initializeTaxes()

      this.originalTransactionModel = this.generateTransactionModel()

      this.initialized = true
    },
    async handleSendToDevoluiva () {
      this.sendToDevoluivaFlag = !this.sendToDevoluivaFlag
      try {
        const sendData = {
          id: this.transactionId,
          receipt: {
            id: this.transaction.receipt.id,
            doNotSendDevoluiva: this.sendToDevoluivaFlag
          }
        }
        this.$store.dispatch('TransactionsStore/editTransaction', { transactionInformation: sendData, originalTransaction: this.transaction })
      } catch (error) {
        this.$store.dispatch('SnackBars/addErrorHandler', { error: error, errorMessage: 'transaction_dont_send_to_devoluiva_error' }, { root: true })
        // Revert change
        this.sendToDevoluivaFlag = !this.sendToDevoluivaFlag
      }
    }
  },
  watch: {
    transactionId: async function (newV, oldV) {
      this.initialized = false
      await this.fetchTransaction()
      await this.fetchCurrentTransactionUserBudgets()
      await this.getBudgetTagTypes()
      this._initializeTransaction()
      this.calculateOptions()
    },
    transactionBudgetId: function (newV, oldV) {
      this.budget = { id: this.transactionBudgetId }
      this.notes = this.transaction.notes
    },
    'transaction.isCompleted': function (newV, oldV) {
      if (newV) {
        this.$emit('transactionCompleted')
      }
      if (!newV && oldV) {
        this.$emit('transactionIncompleted')
      }
    }
  },
  async created () {
    this.orderInputs()
    this.$store.dispatch('TransactionsStore/clearCurrentTransaction')
    this.initialized = false
    // Is mandatory to get the transaction before doing the user budgets call
    await this.fetchTransaction()
    const promises = []
    promises.push(this.fetchCurrentTransactionUserBudgets())

    if (this.vatTypes.length === 0) {
      promises.push(this.$store.dispatch('TransactionsStore/fetchVatTypes'))
    }
    if (this.isSuperBook) {
      const filters = {
        'transaction.id': this.transactionId
      }
      promises.push(this.$store.dispatch('CategoriesStore/setCategoriesFilters', filters))
    }
    Promise.allSettled(promises).then(() => {
      this._initializeTransaction()
      this.calculateOptions()
      this.getBudgetTagTypes()

      this.autoFillTagType()
    })
  },

  beforeRouteUpdate (to, from, next) {
    this.closeModal()
    next()
  },
  destroyed () {
    this.$store.dispatch('TransactionsStore/clearCurrentTransaction')
  }
}
</script>
<style scoped lang="scss" src="@/assets/styles/transactions/transactions-edit.scss">
</style>
<style lang="scss">
.Fuell-Dropdown--container--large {
  height: auto;
  max-width: 325px;
  width: 310px;
}
.Fuell-Dropdown--container--large .label {
  text-align: left;
  margin-left: 5px;
  white-space: normal !important;
}

.icon--margin-text {
  margin-right: 13px;
  margin-left: 10px;
}
.Fuell-Text--bolder {
  font-weight: 500;
}
</style>
<style scoped lang="scss">
.Form--field-error {
  border: 2px solid var(--semantic-negative-main);
  input,
  .currency-symbol {
    color: var(--semantic-negative-main);
  }
}
.taxes-error {
  color: var(--semantic-negative-main);
  img {
    margin-left: 8px;
  }
  span {
    margin-left: 6.5px;
    font-weight: 400;
    font-size: 12px;
    line-height: 16px;
  }
}
</style>
